<div class="expiry-overlay" *ngIf="esVisible()" role="dialog" aria-modal="true">
  <div class="expiry-card">
    <div class="expiry-icon">
      <svg viewBox="0 0 24 24" width="34" height="34" aria-hidden="true">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8" fill="none"/>
        <path d="M12 7 V12 L15.5 14.5" stroke="currentColor" stroke-width="2.2"
              fill="none" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <h3 class="expiry-title">{{ 'auth.sesionPorExpirarTitulo' | translate }}</h3>
    <p class="expiry-text">{{ 'auth.sesionPorExpirarTexto' | translate }}</p>

    <div class="expiry-countdown" aria-live="polite">
      <span class="expiry-countdown-value">{{ formato() }}</span>
      <span class="expiry-countdown-label">{{ 'auth.tiempoRestante' | translate }}</span>
    </div>

    <div class="expiry-actions">
      <button type="button"
              class="expiry-btn expiry-btn-secondary"
              (click)="cerrarSesion()"
              [disabled]="cargando()">
        {{ 'auth.cerrarSesion' | translate }}
      </button>
      <button type="button"
              class="expiry-btn expiry-btn-primary"
              (click)="continuar()"
              [disabled]="cargando()">
        <span *ngIf="!cargando()">{{ 'auth.continuar' | translate }}</span>
        <span *ngIf="cargando()" class="expiry-spinner" aria-hidden="true"></span>
      </button>
    </div>
  </div>
</div>
